import { motion } from 'framer-motion';
import styled from 'styled-components';

import { fadeIn } from '../style';

export const Container = styled.div`
  gap: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  justify-content: space-between;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  gap: 20px;
`;

export const CardContent = styled.div`
  border-radius: 30px;
  width: 100%;
  padding: 1.5rem;
  background: var(--blue-50, #e7e9fa);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  height: 100%;
  box-shadow: -4px 5px 8px 0px rgba(0, 0, 0, 0.25);
`;

export const CardTitle = styled.div`
  opacity: 0;
  animation: 0.5s 0.6s ease ${fadeIn} forwards;

  color: var(--darkk-blue-900, #001840);
  font-family: Inter;
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 145.455% */
`;

export const Description = styled.div`
  opacity: 0;
  animation: 0.5s 0.8s ease ${fadeIn} forwards;

  a {
    color: blue;
    font-family: Inter;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  color: var(--darkk-blue-900, #001840);
  font-family: Inter;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`;

export const Title = styled.h1`
  opacity: 0;
  animation: 0.5s 0.2s ${fadeIn} forwards;

  color: var(--darkk-blue-900, #001840);
  font-family: Inter;
  font-size: 2rem;
  font-style: normal;
  font-weight: 400;
`;

export const Image = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    max-height: 300px;
    min-height: 300px;
  }

  svg {
    width: 100%;
    height: 100%;
    min-width: 300px;
    max-height: 400px;
    min-height: 350px;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: space-between;
  align-items: center;
`;

type IB = {
  variant?: string;
};
export const Button = styled(motion.button)<IB>`
  display: flex;
  padding: 13px 50px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  color: white;
  color: var(--branco, #fff);
  font-family: Inter;
  font-weight: 700;
  cursor: pointer;
  background: #0d4bd0;
  border: 2px solid transparent;

  ${({ variant }) =>
    variant === 'outline'
      ? `
      background: transparent;
      border: 2px solid #042675;
      color: #042675;
    `
      : `
      background: #0d4bd0;
      border: 2px solid transparent;
    `}
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  button {
    width: 100%;
  }
`;
